module.exports = __webpack_public_path__ + "img/ki.425f5fd0.png";